import React from "react";
import { Typography } from "@mui/material";
import "../App.css";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

export default function Footer(props) {
  // propsを受け取る
  const { common_color_navi } = props;

  return (
    <>
      <div style={{ position: "relative" }}>
        <AppBar
          position="fixed"
          style={{ top: "auto", bottom: 0 }}
          sx={{
            backgroundColor: common_color_navi,
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Toolbar variant="dense" style={{ justifyContent: "center" }}>
            <img
              src="./img/cosmos_1_text_none.png"
              alt="img_icon"
              width="30"
              height="30"
            />
            <Typography variant="subtitle1" component="div" sx={{ ml: 1 }}>
              COre Sub MOrisawa System
            </Typography>
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
}
